<template>
  <div class="layout-three-column">
    <slot />
  </div>
</template>

<style scoped>
.layout-three-column {
  display: grid;
  gap: 30px;
}

@media screen and (min-width: 768px) {
  .layout-three-column {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 20px 30px;
  }
}
</style>
